import React, {FunctionComponent} from 'react';
import './InvoiceItemsTable.scss';
import {InvoiceItemsTableItemRow} from "../InvoiceItemsTableItemRow/InvoiceItemsTableItemRow";
import {InvoiceItemsTableGrouping} from "../InvoiceItemsTableGrouping/InvoiceItemsTableGrouping";
import {Item, ItemCategory, ItemSectionSettings} from "../../models/item.model";
import {Invoice} from "../../models/invoice.model";
import {
    InvoiceItemsTableCollapsibleItemRow
} from "../InvoiceItemsTableCollapsibleItemRow/InvoiceItemsTableCollapsibleItemRow";
import {useIsMobileDevice} from "../../hooks/useIsMobileDevice";

interface InvoiceItemsTableProps {
    invoice: Invoice,
    itemSection: ItemSectionSettings;
    categories: ItemCategory[];
}

export const InvoiceItemsTable: FunctionComponent<InvoiceItemsTableProps> = (props) => {
    const {itemSection, categories} = props;
    const isMobileDevice = useIsMobileDevice();
    const ItemComponent = isMobileDevice ? InvoiceItemsTableCollapsibleItemRow : InvoiceItemsTableItemRow;

    const renderInvoiceItemsTableHeader = () => {
        if (isMobileDevice) {
            return <div className={'invoice-items-table-mobile-header'}/>
        }

        return <div className="invoice-items-table-header">
            <div className='invoice-item-title'>Item</div>
            {itemSection.is_price_visible && <div className='invoice-item-price'>Unit Price</div>}
            {itemSection.is_unit_tax_amount_visible &&
                <div className='invoice-item-unit-tax'>{itemSection.tax_short_name} Amount</div>}
            {itemSection.is_quantity_visible && <div className='invoice-item-quantity'>Quantity</div>}
            {itemSection.is_taxed_visible && <div className='invoice-item-tax'>{itemSection.tax_name}</div>}
            {itemSection.is_total_without_tax_visible &&
                <div className='invoice-item-amount-without-tax'>Amount (Ex {itemSection.tax_short_name})</div>}
            {itemSection.is_total_visible && <div className='invoice-item-total'>Amount</div>}
            {itemSection.is_total_with_tax_visible &&
                <div className='invoice-item-amount-with-tax'>Amount ({itemSection.tax_short_name} inc)</div>}
        </div>
    };

    const renderItemGroupCategories = () => {
        if (categories) {
            const invoiceItemGroupCategories = categories.filter((category: ItemCategory) => category.is_group);
            return invoiceItemGroupCategories.map((category: ItemCategory, index) => <InvoiceItemsTableGrouping
                key={index} itemComponent={ItemComponent} category={category} itemSection={itemSection}
            />);
        }
    };

    const renderItemCategoriesWithoutGroup = () => {
        if (categories) {
            const invoiceItemCategoriesWithoutGroup = categories.filter((category: ItemCategory) => !category.is_group);
            return invoiceItemCategoriesWithoutGroup.map((category: ItemCategory, index) => {
                return category.items.map((item, itemIndex: number) => {
                    if (item && item.is_visible && category.is_items_visible) {
                        return <ItemComponent itemSection={itemSection} key={`${index}-${itemIndex}`}
                                              item={item}/>
                    }
                    return null;
                });
            });
        }

        return null;
    };

    return (
        <div className='invoice-items-table'>
            {renderInvoiceItemsTableHeader()}
            {renderItemGroupCategories()}
            {renderItemCategoriesWithoutGroup()}
        </div>
    );
};
